import { render, staticRenderFns } from "./BeServicesFiltersControl.vue?vue&type=template&id=8896dc04&scoped=true"
import script from "./BeServicesFiltersControl.vue?vue&type=script&lang=js"
export * from "./BeServicesFiltersControl.vue?vue&type=script&lang=js"
import style0 from "./BeServicesFiltersControl.vue?vue&type=style&index=0&id=8896dc04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8896dc04",
  null
  
)

export default component.exports